import React from 'react';
import ModulVerwaltung from '../../ModulVerwaltung';

interface Props {
  tenantId: number | null;
}

const ModuleSection: React.FC<Props> = ({ tenantId }) => (
  <div>
    <h3 style={{ marginTop: 0 }}>Module</h3>
    <p style={{ color: 'var(--ink-2)', marginBottom: 16, fontSize: 14 }}>
      Aktiviere oder deaktiviere einzelne Module. Deaktivierte Module sperren automatisch die zugehörigen Agents.
    </p>
    {tenantId ? (
      <ModulVerwaltung tenantId={tenantId} />
    ) : (
      <p style={{ color: 'var(--ink-2)' }}>Kein Mandant zugewiesen.</p>
    )}
  </div>
);

export default ModuleSection;
